<template>
  <div class="__quick-range-selector">
    <q-list dense padding>
      <q-item-label header class="text-sm">{{ $t('Quick select') }}</q-item-label>
      <q-item
        :active="selected === item.value"
        clickable
        v-ripple
        v-for="(item, key) in items"
        :key="key"
      >
        <q-item-section @click="handleClick(item.value)">
          <span class="text-bold">{{ item.label }}</span>
        </q-item-section>
      </q-item>
    </q-list>
  </div>
</template>

<script>
import mixin from './mixin';
import { rangeByType } from '@/components/CustomCharts/lib';

// Chart common lang
import chartLang from '@/components/CustomCharts/lang';

export const messages = {
  en: {
    // Chart common lang
    ...chartLang.en,

    'Quick select': 'Quick select',
  },
  ja: {
    // Chart common lang
    ...chartLang.ja,

    'Quick select': 'クイック選択',
  },
};

export default {
  name: 'QuickRangeSelector',
  mixins: [mixin],
  i18n: { messages: messages },
  props: {
    range: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    options: {
      type: Array,
      default: () => {
        return [
          'mtd',
          'lastMonth',
          'ytd',
          '7days',
          '14days',
          '30days',
          '90days',
          '180days',
          '3months',
          '6months',
          '1year',
        ];
      },
    },
    maxDate: {
      type: Date,
    },
  },
  data() {
    return {
      selected: '',
      selectedRangeString: '',
    };
  },
  watch: {
    range(val) {
      if (this.selectedRangeString !== JSON.stringify(val)) {
        this.selected = '';
      }
    },
  },
  computed: {
    items() {
      const optionList = [
        { label: this.$t('Month to date'), value: 'mtd' },
        { label: this.$t('Last month'), value: 'lastMonth' },
        { label: this.$t('Year to date'), value: 'ytd' },
        { label: this.$t('Last 7 days'), value: '7days' },
        { label: this.$t('Last 14 days'), value: '14days' },
        { label: this.$t('Last 30 days'), value: '30days' },
        { label: this.$t('Last 90 days'), value: '90days' },
        { label: this.$t('Last 180 days'), value: '180days' },
        { label: this.$t('Last 3 months'), value: '3months' },
        { label: this.$t('Last 6 months'), value: '6months' },
        { label: this.$t('Last 1 year'), value: '1year' },
      ];

      const options = [];

      for (const option of this.options) {
        const found = optionList.find(item => item.value === option);
        if (found) options.push(found);
      }

      return options;
    },
  },
  methods: {
    handleClick(val) {
      const range = rangeByType(val, this.maxDate);
      this.$emit('change', range);

      this.selected = val;
      this.selectedRangeString = JSON.stringify(range);
    },
  },
};
</script>

<style lang="scss" scoped>
.__quick-range-selector {
  min-width: 105px;

  .buttons {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
